import { Spinner } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function LoadingPage() {
  const { t } = useTranslation();
  return (
    <div className="h-screen flex justify-center items-center ">
      <Spinner size="lg" variant="light-grey">
        {t('actions.loading')}
      </Spinner>
    </div>
  );
}
